import { Outlet, Route, Routes } from "react-router-dom";
import Login from "./Pages/Auth/Login";
import TaxGroup from "./Pages/TaxGroup/Index";

const Router = () => {
  const PublicRoute = ({ children, ...rest }) => {
    return (
      <div>
        <Outlet />
      </div>
    );
  };
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route exact path="/" element={<Login />} />
      </Route>
      <Route>
        <Route exact path="/taxList" element={<TaxGroup />} />
      </Route>
  
    </Routes>
  );
};
export default Router;
